<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="dialog"
      persistent
      transition="dialog-bottom-transition"
      fullscreen
    >
      <v-card>
        <v-toolbar color="primary">
          <v-toolbar-title>
            STORE: {{ selected_item.store_name_th }}
            <span v-if="selected_item.store_name_en"
              >( {{ selected_item.store_name_en }} )</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('setDialog', false), (reject_msg = '')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text
          v-if="isLoadingStore == true"
          style="height: calc(100vh - 64px - 81px)"
        >
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              height: 100%;
            "
          >
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <div><br />Loading ...</div>
          </div>
        </v-card-text>
        <v-card-text v-if="isLoadingStore == false" class="pa-0">
          <v-layout
            row
            wrap
            style="height: calc(100vh - 64px - 81px); overflow: auto"
          >
            <v-flex xs12 sm4 style="padding: 24px">
              <div class="my-card">
                <div class="text-title">STORE LOGO: &nbsp;</div>
                <div class="img-logo-layout">
                  <a
                    :href="store_detail.store_image_logo"
                    target="_blank"
                    style="text-decoration: none; color: white"
                  >
                    <img
                      :src="store_detail.store_image_logo"
                      class="img-logo"
                    />
                  </a>
                </div>
                <div class="text-title">STORE IMAGE: &nbsp;</div>
                <div class="images-scroll">
                  <a
                    :href="info.store_image"
                    v-for="(info, index) in store_detail.store_image"
                    :key="`image-${index}`"
                    target="_blank"
                    style="
                      text-decoration: none;
                      color: white;
                      margin-right: 10px;
                    "
                    class="img-logo-layout"
                  >
                    <img :src="info.store_image" class="img-logo" />
                  </a>
                </div>
                <div class="text-title">STORE BUSSINESS IMAGE: &nbsp;</div>
                <div class="images-scroll">
                  <v-layout wrap>
                    <v-flex
                      xs6
                      v-for="(info, index) in store_detail.store_business_image"
                      :key="`store_business_image-${index}`"
                    >
                      <a
                        :href="info.store_business_image"
                        target="_blank"
                        style="
                          text-decoration: none;
                          color: white;
                          margin-right: 10px;
                        "
                        class="img-logo-layout"
                      >
                        <img
                          :src="info.store_business_image"
                          class="img-logo"
                        />
                      </a>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
              <div class="my-card">
                <div class="flex-row">
                  <div class="text-title">STORE BANK NAME: &nbsp;</div>
                  <div class="text-content">
                    {{
                      store_detail.store_bank
                        ? store_detail.store_bank.store_bank_account_name
                        : ""
                    }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">STORE BANK NUMBER: &nbsp;</div>
                  <div class="text-content">
                    {{
                      store_detail.store_bank
                        ? store_detail.store_bank.store_bank_account_number
                        : ""
                    }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">STORE BANK: &nbsp;</div>
                  <div class="text-content">
                    {{
                      store_detail.store_bank
                        ? store_detail.store_bank.store_bank_bank_name_th +
                          "(" +
                          store_detail.store_bank.store_bank_bank_code +
                          ")"
                        : ""
                    }}
                  </div>
                </div>

                <div class="text-title">STORE BANK IMAGE: &nbsp;</div>
                <a
                  v-if="
                    store_detail.store_bank &&
                    store_detail.store_bank.store_bank_image
                  "
                  :href="store_detail.store_bank.store_bank_image"
                  target="_blank"
                  style="
                    text-decoration: none;
                    color: white;
                    margin-right: 10px;
                  "
                  class="img-logo-layout"
                >
                  <img
                    :src="store_detail.store_bank.store_bank_image"
                    class="img-logo"
                  />
                </a>
              </div>
            </v-flex>
            <v-flex xs12 sm4 style="padding: 24px">
              <div class="my-card">
                <div class="flex-row">
                  <div class="text-title">STORE CODE: &nbsp;</div>
                  <div class="text-content">{{ store_detail.store_code }}</div>
                </div>
                <div class="flex-row">
                  <div class="text-title">STORE DESCRIPTION TH: &nbsp;</div>
                  <div class="text-content">
                    {{ store_detail.store_description_th }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">STORE DESCRIPTION EN: &nbsp;</div>
                  <div class="text-content">
                    {{ store_detail.store_description_en }}
                  </div>
                </div>
                <div style="display: flex; align-items: center">
                  <span class="text-title pr-2">STORE TYPE:</span>
                  <span
                    v-for="(info, index) in store_detail.store_type"
                    :key="`type-${index}`"
                    class="text-content"
                  >
                    {{ info.store_type_name_th }}
                    {{ index == store_detail.store_type.length - 1 ? "" : "," }}
                  </span>
                </div>
                <div class="text-title">STORE TEL.: &nbsp;</div>
                <li
                  v-for="(info, index) in store_detail.store_tel"
                  :key="`tel-${index}`"
                  class="text-content"
                >
                  {{ "+66" + info.tel }} &nbsp;
                </li>
                <div class="flex-row">
                  <div class="text-title">STORE EMAIL: &nbsp;</div>
                  <div class="text-content">{{ store_detail.store_email }}</div>
                </div>
              </div>

              <div class="my-card">
                <div class="flex-row">
                  <div class="text-title">
                    PRICE RANGE: {{ store_detail.store_price_range_start }} -
                    {{ store_detail.store_price_range_end }}
                  </div>
                  <div class="text-content"></div>
                </div>
              </div>

              <div class="my-card">
                <!-- <div class="text-title">Store Time &nbsp;</div> -->
                <div v-for="(day, index) in showTime" :key="index">
                  <div>{{ day.name.toUpperCase() }}</div>
                  <div v-if="day.time_open != null || day.time_close != null">
                    - {{ day.time_open }} to {{ day.time_close }}
                  </div>
                  <div v-if="day.time_open2 != null || day.time_close2 != null">
                    - {{ day.time_open2 }} to {{ day.time_close2 }}
                  </div>
                  <div
                    v-if="
                      day.time_open2 == null &&
                      day.time_close2 == null &&
                      day.time_open == null &&
                      day.time_close == null
                    "
                  >
                    - Close today
                  </div>
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm4 style="padding: 24px">
              <div class="my-card">
                <div class="flex-row">
                  <div class="text-title">ADDRESS TH: &nbsp;</div>
                  <div class="text-content">
                    {{ selected_item.store_address_th }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">ADDRESS EN: &nbsp;</div>
                  <div class="text-content">
                    {{ selected_item.store_address_en }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">PROVINEC: &nbsp;</div>
                  <div class="text-content">
                    {{ selected_item.store_province_name }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">DISTRICT: &nbsp;</div>
                  <div class="text-content">
                    {{ store_detail.store_district_id }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">SUB DISTRICT: &nbsp;</div>
                  <div class="text-content">
                    {{ store_detail.store_sub_district_id }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">ZIPCODE: &nbsp;</div>
                  <div class="text-content">
                    {{ store_detail.store_zipcode_id }}
                  </div>
                </div>
                <div style="display: flex; align-items: center">
                  <div class="text-title pr-1">LATITUDE: &nbsp;</div>
                  <div class="text-content">{{ store_detail.store_lat }}</div>
                </div>
                <div style="display: flex; align-items: center">
                  <div class="text-title pr-1">LONGITUDE: &nbsp;</div>
                  <div class="text-content">{{ store_detail.store_long }}</div>
                </div>
              </div>
              <div class="my-card">
                <div class="text-title">ADDRESS NOTE: &nbsp;</div>
                <div class="text-content">{{ store_detail.store_note }}</div>
              </div>
              <GoogleMap
                :latitude="parseFloat(store_detail.store_lat)"
                :longitude="parseFloat(store_detail.store_long)"
                :height="350"
                :zoom="15"
                :mapType="'all'"
                :draggable="false"
              ></GoogleMap>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions style="border-top: 2px solid #f2f2f2">
          <v-spacer />
          <v-btn
            depressed
            color="red"
            class="white--text"
            @click="toRejectStore()"
            style="height: 40px; margin-left: 8px"
            :disabled="approving_store"
            :loading="rejecting_store"
            round
            >reject</v-btn
          >
          <v-btn
            depressed
            round
            color="green darken-1"
            class="white--text"
            @click="approveStore()"
            style="height: 40px"
            :loading="approving_store"
            :disabled="rejecting_store"
            >Approve</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="rejectDialog" width="400px">
      <v-card>
        <div class="pl-3 pr-3 pt-3">
          <h2>Do you want to reject ?</h2>
        </div>
        <v-card-text class="pt-0">
          <v-text-field
            label="Message"
            v-model="reject_msg"
            hide-details
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              rejectDialog = false;
              reject_msg = '';
            "
          >
            <v-icon medium color="error">close</v-icon>
          </v-btn>
          <v-btn icon @click="rejectStore()">
            <v-icon medium color="success">check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  props: {
    dialog: {
      type: Boolean,
      default() {
        return false;
      },
    },
    selected_item: {
      type: Object,
      default() {
        return { msg: null };
      },
    },
  },
  data() {
    return {
      rejectDialog: false,
      reject_msg: "",
      store_detail: {},
      isLoadingStore: false,
      rejecting_store: false,
      approving_store: false,
      showTime: [
        {
          name: "sun",
          time_open: null,
          time_close: null,
          time_open2: null,
          time_close2: null,
        },
        {
          name: "mon",
          time_open: null,
          time_close: null,
          time_open2: null,
          time_close2: null,
        },
        {
          name: "tue",
          time_open: null,
          time_close: null,
          time_open2: null,
          time_close2: null,
        },
        {
          name: "wed",
          time_open: null,
          time_close: null,
          time_open2: null,
          time_close2: null,
        },
        {
          name: "thu",
          time_open: null,
          time_close: null,
          time_open2: null,
          time_close2: null,
        },
        {
          name: "fri",
          time_open: null,
          time_close: null,
          time_open2: null,
          time_close2: null,
        },
        {
          name: "sat",
          time_open: null,
          time_close: null,
          time_open2: null,
          time_close2: null,
        },
      ],
    };
  },
  watch: {
    async dialog() {
      if (this.dialog == true) {
        let store_province_name = this.selected_item.store_province_name || "";
        let province = store_province_name.replace(" ", "").toLowerCase();
        let config_path = {
          province,
          store_id: this.selected_item.store_id,
          service: this.selected_item.service,
        };
        this.isLoadingStore = true;
        this.store_detail = await this.$store.dispatch(
          "fetchStoreApproveBack/getStoreDetailByIDAndService",
          config_path
        );

        for (let field in this.store_detail.store_time) {
          for (let val of this.showTime) {
            if (field.includes(val.name)) {
              if (field.includes(2)) {
                if (
                  field.includes("open") &&
                  this.store_detail.store_time[field] != null
                ) {
                  val.time_open2 = this.store_detail.store_time[field];
                } else if (this.store_detail.store_time[field] != null) {
                  val.time_close2 = this.store_detail.store_time[field];
                }
              } else {
                if (
                  field.includes("open") &&
                  this.store_detail.store_time[field] != null
                ) {
                  val.time_open = this.store_detail.store_time[field];
                } else if (this.store_detail.store_time[field] != null) {
                  val.time_close = this.store_detail.store_time[field];
                }
              }
            }
            // console.log(day);
          }
          // console.log( this.store_detail.store_time[val]);
        }

        this.isLoadingStore = false;
        //   getStoreDetail
      }
    },
  },
  methods: {
    takeTime() {},
    async approveStore() {
      this.approving_store = true;
      let store_province_name = this.selected_item.store_province_name || "";
      let province = store_province_name.replace(" ", "").toLowerCase();
      let data = {
        config_path: {
          province,
          store_id: this.selected_item.store_id,
        },
        form: {
          store_use_pos: 3,
          store_reject_msg: null,
        },
      };
      let check = await this.$store.dispatch(
        "fetchStoreApproveBack/approveStoreApprove",
        data
      );
      this.approving_store = false;
      if (check == true) {
        this.reject_msg = "";
        this.$emit("setDialog", false);
      }
    },
    toRejectStore() {
      this.rejectDialog = true;
    },
    async rejectStore() {
      this.rejectDialog = false;
      this.rejecting_store = true;
      let store_province_name = this.selected_item.store_province_name || "";
      let province = store_province_name.replace(" ", "").toLowerCase();
      let data = {
        config_path: {
          province,
          store_id: this.selected_item.store_id,
        },
        form: {
          store_use_pos: 1,
          store_reject_msg: this.reject_msg,
        },
      };
      let check = await this.$store.dispatch(
        "fetchStoreApproveBack/rejectStoreApprove",
        data
      );
      this.rejecting_store = false;
      if (check == true) {
        this.reject_msg = "";
        this.$emit("setDialog", false);
      }
    },
  },
};
</script>

<style scoped>
.images-scroll {
  display: flex;
  max-height: 300px;
  width: auto;
  overflow-y: scroll;
}
.img-logo-layout {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  height: 120px;
  width: 120px;
  min-width: 120px;
  position: relative;
  text-align: center;
  color: white;
  font-size: 18px;
  cursor: pointer;
  background: white;
  -webkit-box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  border-radius: 20px;
}
.img-logo {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  object-fit: cover;
}
.img-text {
  background-image: linear-gradient(to bottom, transparent, black);
  width: 100%;
  line-height: 30px;
  border-radius: 0 0 20px 20px;
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.text-title {
  font-size: 14px;
  font-weight: 500;
  color: #666;
}
.text-content {
  font-size: 16px;
  font-weight: 500;
}
.my-card {
  border: 2px solid rgb(242, 242, 242);
  border-radius: 5px;
  padding: 2px 5px;
  margin-bottom: 10px;
}
</style>


